import { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import UserContext from "../context/UserContext";
import Task from "./Task";
import { apiURL } from "../api";

export default function TasksList({ section, children }) {
  const [tasks, setTasks] = useState([]);
  const { userData } = useContext(UserContext);

  const navigate = useNavigate();

  const navigateToCreateNewTask = () => {
    navigate(`/tasks/create`);
  };

  const getTasksList = () => {
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify({
        method: "task.getList",
        params: {
          section: section,
        },
      }),
    };

    fetch(apiURL + "/public", requestOptions)
      .then((response) => response.json())
      .then((response) => {
        setTasks(response.result);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {});
  };

  useEffect(() => {
    getTasksList();
  }, [section]);

  return (
    <>
      <div className="tasks container">
        {children}
        {userData && (
          <button
            type="button"
            className="btn btn-sm btn-outline-success text-nowrap my-3 p-2"
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            data-bs-title="Create new task"
            data-bs-target="#createNewTask"
            onClick={navigateToCreateNewTask}
          >
            <i className="bi bi-building-fill-add pe-1"></i>Create new task
          </button>
        )}
        {tasks.map((task, index) => (
          <div className="taskList row" key={task.uuid} id={task.uuid}>
            <div className="col-12">
              <Task task={task} index={index + 1} getTasksList={getTasksList} />
            </div>
          </div>
        ))}
      </div>
    </>
  );
}
